import React, {Fragment} from "react";
import {Menu, Transition} from "@headlessui/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown} from "@fortawesome/pro-regular-svg-icons";
import ProfilePicture from "./presentational/ProfilePicture";
import * as Sentry from "@sentry/react";
import {useAuth0} from "@auth0/auth0-react";

type ProfileDropdownPanelProps = {}

const ProfileDropdownPanel: React.FC<ProfileDropdownPanelProps> = () => {
    const {user, logout} = useAuth0();
    const classNames = (...classes) => {
        return classes.filter(Boolean).join(' ')
    }

    if (!user) {
        return (
            <div className="flex items-center ml-4 md:ml-6">
                <Menu as="div" className="ml-3 relative">
                    <Menu.Button className="max-w-xs flex items-center text-sm p-2 lg:hover:bg-gray-50">
                        <span className="hidden ml-3 text-gray-700 text-sm font-medium lg:block whitespace-nowrap">
                            Anonymous
                        </span>
                        <FontAwesomeIcon icon={faChevronDown} className="hidden shrink-0 ml-1 h-3 w-3 text-gray-400 lg:block" aria-hidden="true"/>
                    </Menu.Button>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black/5 focus:outline-hidden">
                            <Menu.Item>
                                {({active}) => (
                                    <a
                                        href="/"
                                        className={classNames(active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700')}
                                    >
                                        Your Profile
                                    </a>
                                )}
                            </Menu.Item>
                        </Menu.Items>
                    </Transition>
                </Menu>
            </div>
        );
    }

    Sentry.setUser({'email': user.email, 'name': user.name});

    return (
        <div className="flex items-center ml-4 md:ml-6">
            <Menu as="div" className="ml-3 relative">
                <div>
                    <Menu.Button className="max-w-xs flex items-center text-sm p-2">
                        <ProfilePicture user={user}/>
                        <span className="hidden ml-3 text-gray-700 text-sm font-medium lg:block whitespace-nowrap">
                      <span className="sr-only">Open user menu for </span>{user.name}
                    </span>
                        <FontAwesomeIcon icon={faChevronDown} className="hidden shrink-0 ml-1 h-3 w-3 text-gray-400 lg:block" aria-hidden="true"/>
                    </Menu.Button>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black/5 focus:outline-hidden">
                        <Menu.Item>
                            <a
                                href="/"
                                onClick={() =>
                                    logout({
                                        clientId: '',
                                        logoutParams: {
                                            returnTo: window.location.origin,
                                        },
                                    })
                                }
                                className="block px-4 py-2 text-sm text-gray-700"
                            >
                                Logout
                            </a>
                        </Menu.Item>
                    </Menu.Items>
                </Transition>
            </Menu>
        </div>
    )
}

export default ProfileDropdownPanel;
